<template>
  <a :href="this.href" :target="this.target">
    <i :class="this.icon"/>
    {{this.text}}
  </a>
</template>

<script>
export default {
  name: 'ScDownloadLinkComponent',
  props: {
    icon: {
      type: String,
      default: 'sc-icon-download'
    },
    text: {
      type: String,
      required: true
    },
    href: {
      type: String,
      required: true
    },
    target: {
      type: String,
      default: '_blank'
    }
  }
}
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
  color: $sc-downloadlink-color;

  &:link {
    color: $sc-downloadlink-color;
  }

  &:active {
    color: $sc-downloadlink-color;
  }

  &:visited {
    color: $sc-downloadlink-color;
  }
}
</style>
